module.exports = __webpack_public_path__ + "img/logo_w.fc9f0613.png";